import { Frame } from '@/lib/SFrame'

const NAV_HEIGHT = 64
export const styles = {
    parent: new Frame().shared({
        backgroundColor: 'rgba(49, 49, 49, 0.8)',
        borderRadius: '10px',
    }),
}
